import { EntityPluralLower } from '@enums/EntityName';
import EntityType from '@enums/EntityType';
import unassignedPerson from '@utils/people/unassignedPerson';
import isOutsideLevel from './isOutsideLevel';

const emptyCollection = (design) => {
  return {
    id: design.id,
    colors: design.colors,
    entities: {
      [EntityType.ACTIVITY]: null,
      [EntityType.ROLE]: null,
      [EntityType.GROUP]: null,
      [EntityType.PERSON]: null,
    },
  };
};

export default function collectEntities({
  design,
  entity,
  entities,
  id,
  includeUnallocated,
  level,
}) {
  if (!entity) {
    return emptyCollection(design);
  }
  // We need this check to avoid included managerial roles that sit outside
  // the current design level.
  const activity = entity.__type === EntityType.ACTIVITY ? entity : null;

  if (
    activity &&
    activity.owner_type !== EntityType.ROLE &&
    !includeUnallocated
  ) {
    return design ? emptyCollection(design) : null;
  }

  const role =
    activity?.owner_type === EntityType.ROLE
      ? entities[EntityPluralLower.ROLE]?.[activity.owner_uuid]
      : entity.__type === EntityType.ROLE
        ? entity
        : null;
  const isGroupActivity =
    entity.__type === EntityType.ACTIVITY &&
    entity.owner_type === EntityType.GROUP;

  const group = role
    ? entities[EntityPluralLower.GROUP]?.[role.group_uuid]
    : entity.__type === EntityType.GROUP
      ? entity
      : isGroupActivity
        ? entities[EntityPluralLower.GROUP]?.[entity.owner_uuid]
        : null;
  const person = role
    ? role.__person || unassignedPerson()
    : entity.__type === EntityPluralLower.PERSON
      ? entity
      : unassignedPerson();

  if (isOutsideLevel({ entity, activity, role, group }, level)) {
    return design ? emptyCollection(design) : null;
  }

  return {
    id: design?.id || 'primary',
    colors: design?.colors,
    entities: {
      [EntityType.ACTIVITY]: activity,
      [EntityType.ROLE]: role,
      [EntityType.GROUP]: group,
      [EntityType.PERSON]: person,
    },
  };
}
